module.exports = __webpack_public_path__ + "static/media/upgrade_01.3f1c2325.png";